import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Partido } from "src/app/models/partido";
import { User } from 'firebase';
import { Quiniela } from "src/app/models/quiniela";
import { Jugador } from "src/app/models/jugador";
import { QuinielaJugada } from "src/app/models/quiniela-jugada";
import { QuinielasService } from "src/app/services/quinielas.service";
import { PlantillasService } from "src/app/services/plantillas.service";
import { PartidosService } from "src/app/services/partidos.service";
import { JugadorService } from "src/app/services/jugadores.service";
import { SmsService } from "src/app/services/sms.service";
import { QuinielaJugadaService } from "src/app/services/quiniela-jugada.service";
import { AuthService } from 'src/app/services/auth.service';
import { Plantilla } from "src/app/models/plantilla";
import { AdminService } from 'src/app/services/admin.service';
import { Admin } from 'src/app/models/admin';
import Swal from 'sweetalert2';
import { TablaService } from 'src/app/services/tabla.service';
import { Tabla } from 'src/app/models/tabla';
import { JsonPipe } from "@angular/common";

@Component({
  selector: "app-quiniela-page",
  templateUrl: "./quiniela-page.component.html",
  styleUrls: ["./quiniela-page.component.css"],
})
export class QuinielaPageComponent implements OnInit {
  quiniela: Quiniela;
  partidos: Array<Partido> = [];
  isLoading = true;
  quinielasJugadas: Array<QuinielaJugada> = [];
  completo = false;
  jugadoresByQuiniela: Array<Jugador> = [];
  plantillas: Array<Plantilla> = [];
  user: User = null;
  isAuthenticated = false;
  admins: Array<Admin> = [];


  constructor(
    private rutaActiva: ActivatedRoute,
    private QuinielasService: QuinielasService,
    private PartidosService: PartidosService,
    private JugadorService: JugadorService,
    private QuinielaJugadaService: QuinielaJugadaService,
    private PlantillasService: PlantillasService,
    private AdminService: AdminService,
    private SmsService: SmsService,
    private router: Router,
    private toastr: ToastrService,
    private authService: AuthService,
    private JugadoresService: JugadorService,
    private TablaService: TablaService,
  ) { }

  ngOnInit(): void {
    // Obtener por parametro de URL el ID de la Quiniela
    var idQuiniela = this.rutaActiva.snapshot.params.id;

    // Obtener la Quiniela con ese ID mediante el Servicio
    this.QuinielasService.getQuiniela(idQuiniela).subscribe((item) => {
      this.quiniela = {
        $key: item.payload.id,
        ...item.payload.data(),
      };
      // Imprimiendo la Quiniela
      console.log(this.quiniela);

      this.getCurrentUser();

      this.getAllPartidosByIdQuiniela();
    });

  }

  getCurrentUser(): void {
    this.authService.getCurrentUser().subscribe((response) => {
      if (response) {
        this.user = response;
        this.isAuthenticated = true;

        this.AdminService.getAdmin(this.user.email).subscribe((items) => {
          // Setting up admins
          this.admins = items.map(
            (item) =>
            ({
              ...item.payload.doc.data(),
              $key: item.payload.doc.id,
            } as Admin)
          );
          console.log(this.admins)
          if (this.quiniela.user != this.user.email && this.admins.length == 0) {
            this.router.navigate(['/quinielas']);
          }

        });
        return;
      }
      this.isAuthenticated = false;
    });
  }

  AgregarPartido() {
    // Control para evitar submit en caso que falte algo
    let error = false;

    // Validando los inputs que no esten vacios
    const inputs = ["Fecha", "Equipo1", "Equipo2"];
    inputs.map(function (id) {
      document.getElementById(id).classList.remove("is-invalid");
      if ((<HTMLInputElement>document.getElementById(id)).value == "") {
        document.getElementById(id).classList.add("is-invalid");
        error = true;
      } else {
        document.getElementById(id).classList.add("is-valid");
      }
    });

    // Si error es Falso entonces se procede a crear el Objeto y enviar por medio del Servicio
    if (!error) {
      // Limpiar las alertas del Formulario
      inputs.map(function (id) {
        document.getElementById(id).classList.remove("is-valid");
      });

      // Creando el Objeto con el Modelo
      const dataPartido: Partido = {
        idQuiniela: this.quiniela.$key,
        fecha: (<HTMLInputElement>document.getElementById("Fecha")).value,
        contrincante1: (<HTMLInputElement>document.getElementById("Equipo1"))
          .value,
        resultado1: null,
        contrincante2: (<HTMLInputElement>document.getElementById("Equipo2"))
          .value,
        resultado2: null,
      };

      // Enviar a Firebase por medio del Servicio
      this.PartidosService.createPartido(dataPartido).then((res) => {
        console.log("Se ha creado con exito el Partido", dataPartido);

        // Limpiar el Formulario
        (<HTMLInputElement>document.getElementById("Fecha")).value = "";
        (<HTMLInputElement>document.getElementById("Equipo1")).value = "";
        (<HTMLInputElement>document.getElementById("Equipo2")).value = "";
      });
    }
  }

  // Obtener las Partidos
  getAllPartidosByIdQuiniela(): void {
    var aux = false;
    this.isLoading = true;
    this.PartidosService.getAllPartidosByIdQuiniela(
      this.quiniela.$key
    ).subscribe((items) => {
      // Setting up partidos
      this.partidos = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Partido)
      );

      // Ordenar los Partidos
      this.partidos.sort((x, y) => +new Date(x.fecha) - +new Date(y.fecha));

      // Terminar cargando
      this.isLoading = false;

      if (!aux) {
        //Llenado Platilla Automaticamente
        this.cargarPlatilla();
        aux = true;
      }
    });
  }

  BorrarPartido(id) {
    // Se elimina el Partido con el Servicio correspondiente a Partidos
    console.log(id);
    this.PartidosService.deletePartido(id).then((res) => {
      console.log("Se ha eliminado con exito el Partido con ID", id);
    });
  }

  cerrarQuiniela() {
    // Enviar el Alerta
    this.toastr.success("Se ha cerrado con éxito su Quiniela!");

    // Pasa la Quiniela a Activa
    this.quiniela.activa = true;

    // Notificar al administrador de la plataforma
    var numero = '+584122924248'
    var texto = "*TuQuinielaYa:* \n\nInformación: El usuario " + this.user.email + " ha creado una nueva quiniela llamada: " + this.quiniela.titulo + "\n\nDetalles de la quiniela:\n\n- Descripción: " + this.quiniela.descripcion + "\n- URL: " + this.quiniela.url + "\n- Datos de pago: " + this.quiniela.datos_de_pago + "\n- Precio: " + this.quiniela.precio + " " + this.quiniela.moneda + "\n- Porcentaje: " + this.quiniela.porcentaje + "%\n- Teléfono de contacto: " + this.quiniela.telefono + "\n- Número: " + this.quiniela.numero + "\n- Pote: " + this.quiniela.pote + "\n- ¿Empezada?: " + (this.quiniela.empezada ? "Sí" : "No") + "\n- Fecha: " + this.quiniela.fecha;
    this.SmsService.enviar(numero, texto);

    // Actualizando esa Quiniela en Base de Datos
    this.isLoading = true;
    this.QuinielasService.updateQuiniela(
      this.quiniela,
      this.quiniela.$key
    ).then((res) => {
      this.isLoading = false;
    });
  }

  cerrar() {
    Swal.fire({
      title: 'Alerta',
      text: "Al cerrar la quiniela no podrás agregar mas partidos.\n¿Estas seguro?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar',
      reverseButtons: true
    }).then((result) => {
      if (result.isConfirmed) {
        this.cerrarQuiniela();
      }
    })
  }

  async editarResultado(partido: Partido) {
    this.isLoading = true;
    // Cerrando Modal
    (<HTMLInputElement>(
      document.getElementById("CloseButtonPartido-" + partido.$key)
    )).click();



    // Se recibe el objeto Partido con todos los datos y solo falta capturar los inputs de los resultados
    partido.resultado1 = (<HTMLInputElement>(
      document.getElementById("Resultado1-" + partido.$key)
    )).value;
    partido.resultado2 = (<HTMLInputElement>(
      document.getElementById("Resultado2-" + partido.$key)
    )).value;

    // Se envia a Base de Datos para actualizar dicho partido
    this.PartidosService.updatePartido(partido, partido.$key).then((res) => {
      console.log("Se ha editado el Partido: ", partido);
    });

    // Partidos Jugados de ese Partido de la Quiniela
    const qjs = this.QuinielaJugadaService.getAllPartidosJugadosByIdPartido(
      partido.$key
    ).subscribe((items) => {
      // Setting up Partidos de Quinielas
      this.quinielasJugadas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as QuinielaJugada)
      );

      qjs.unsubscribe();

      // Sumar puntos a en los Partidos de las Quinielas

      for (let quinielaJugada of this.quinielasJugadas) {
        console.log("Recorriendo quiniela jugada ", quinielaJugada);

        // Buscar el jugador de este partdio para restar puntos que tenia en este partido
        const JugadorServiceGetJugador = this.JugadorService.getJugador(quinielaJugada.id_jugador).subscribe((item) => {
          var jugador = {
            $key: item.payload.id,
            ...item.payload.data(),
          };
          // unsubscribe porque no necesitamos quedar subscritos

          // Restamos los puntos al puntaje del jugador
          console.log(jugador, this.quinielasJugadas, quinielaJugada)
          JugadorServiceGetJugador.unsubscribe();
          jugador.puntaje = jugador.puntaje - quinielaJugada.ppr - quinielaJugada.ppe;
          // Colocamos en 0 PPR y PPE para que se vuelva a generar el calculo
          quinielaJugada.ppr = 0;
          quinielaJugada.ppe = 0;
          if (
            quinielaJugada.resultado1 == partido.resultado1 &&
            quinielaJugada.resultado2 == partido.resultado2
          ) {
            // Caso 1 (Pegar Resultado = 3 pts)
            quinielaJugada.ppr = 2;
            quinielaJugada.ppe = 1;
          } else if (
            parseInt(quinielaJugada.resultado1) -
            parseInt(quinielaJugada.resultado2) ==
            parseInt(partido.resultado1) - parseInt(partido.resultado2)
          ) {
            // Caso 2 (Pegar Empate = 1 pts)
            quinielaJugada.ppe = 1;
          } else if (
            (parseInt(quinielaJugada.resultado1) <
              parseInt(quinielaJugada.resultado2) &&
              parseInt(partido.resultado1) < parseInt(partido.resultado2)) ||
            (parseInt(quinielaJugada.resultado1) >
              parseInt(quinielaJugada.resultado2) &&
              parseInt(partido.resultado1) > parseInt(partido.resultado2))
          ) {
            // Caso 3 (Pegar Ganador = 1 pts)
            quinielaJugada.ppe = 1;
          }

          jugador.puntaje = jugador.puntaje + quinielaJugada.ppr + quinielaJugada.ppe;

          // Enviar a actualizar la Quinielajugada
          this.QuinielaJugadaService.updateQuinielaJugada(quinielaJugada, quinielaJugada.$key).then((res) => {
            console.log("Se actualizo: " + quinielaJugada);
          });

          // Enviar a actualizar el Jugador
          this.JugadorService.updateJugador(jugador, quinielaJugada.id_jugador).then((res) => {
            console.log("Se actualizo: " + JSON.stringify(jugador));
          });




        });
      }

      var espera = this.quinielasJugadas.length * 100 + 10000;
      let timerInterval
      Swal.fire({
        title: 'Espere...',
        html: 'Se esta cargando el resultado y calculando los puntos de cada jugador. Por favor espere <b></b> millisegundos. Este proceso dependera de la cantidad de participantes de la quiniela.',
        timer: espera,
        timerProgressBar: true,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
          const b = Swal.getHtmlContainer().querySelector('b')
          timerInterval = setInterval(() => {
            b.textContent = `${Swal.getTimerLeft()}`
          }, 100)
        },
        willClose: () => {
          clearInterval(timerInterval)
        }
      }).then((result) => {
        /* Read more about handling dismissals below */
        if (result.dismiss === Swal.DismissReason.timer) {
          console.log('I was closed by the timer')
          this.isLoading = false;

          // Escribir true que ya esta empezada la quiniela 
          this.quiniela.empezada = true;
          // Envia a actualizar la quiniela para ponerla como empezada
          this.QuinielasService.updateQuiniela(this.quiniela, this.quiniela.$key).then((res) => {
            console.log("Se ha editado la quiniela para ponerla como empezada");
          });

          // Se obtienen todos los juagadores para generar Objeto con todos los jugadores para que sean menos lecturas
          var jugadores: Array<Jugador> = [];
          const jugadoresServiceSubs = this.JugadoresService.getAllJugadoresByIdQuiniela(this.quiniela.$key).subscribe((items) => {
            // Setting up jugadores
            jugadores = items.map(
              (item) =>
              ({
                ...item.payload.doc.data(),
                $key: item.payload.doc.id,
              } as Jugador)
            );
            jugadoresServiceSubs.unsubscribe();

            console.log(jugadores)
            // Filtrar jugadores confirmados
            var jugadoresActivos = [];
            for (let jugador of jugadores) {
              if (jugador.confirmado) {
                jugadoresActivos.push(jugador);
              }
            }
            jugadores = jugadoresActivos;
            //Armando objeto para la coleccion data tabla
            const dataTabla: Tabla = {
              idQuiniela: this.quiniela.$key,
              tabla: jugadores,
            };

            // Obtener la tabla a partir de un ID o $Key de la tabla
            const tablaServiceSub = this.TablaService.getAllTablasByIdQuiniela(this.quiniela.$key).subscribe((items) => {
              var tabla = items.map(
                (item) =>
                ({
                  ...item.payload.doc.data(),
                  $key: item.payload.doc.id,
                } as Tabla)
              );
              tablaServiceSub.unsubscribe();

              // Si la loongitud de la peticion a DB es diferente a 0 significa que si existe esa tabla en DB 
              if (tabla.length != 0) {
                // Envia a actualizar
                this.TablaService.updateTabla(dataTabla, tabla[0].$key).then((res) => {
                  console.log("SE ACTUALIZO LA TABLA DE LA QUINIELA.")
                });
              } else {
                // Envia a crear la tabla
                this.TablaService.createTabla(dataTabla).then((res) => {
                  console.log("SE CREO LA TABLA DE LA QUINIELA.")
                });
              }
              // Enviar por WhatsApp al finalizar el for
              this.enviarWhatsApp(partido, dataTabla);
              console.log("Enviar Mensajes por WhatsApp");
            });
          });
        }
      })


    });
  }

  enviarWhatsApp(partido: Partido, tabla: Tabla) {
    var jugadores = [];

    jugadores = tabla.tabla;

    // Ordenar los Jugadores por sus puntajes (Menor a Mayor)
    jugadores.sort(function (x, y) {
      return x.puntaje - y.puntaje;
    });
    // Ejecutando un reverse para que queden de Mayor a Menor
    jugadores.reverse();

    // Enviar SMS a tres jugadores aleatorio
    for (let i = 0; i < jugadores.length; i++) {
      var numero = jugadores[i].contacto;
      var posicion = i + 1; // Calculando la Posicion en la Tabla
      var aleatorio = Math.floor(Math.random() * (10 - 1 + 1) + 1);

      // Generando el mensaje
      if (aleatorio == 1) {
        var texto =
          "⚽ *TuQuinielaYa* ⚽ \n Hola " + jugadores[i].nombre +
          ". Por los momentos usted se encuentra de " + posicion + " en la tabla de puntuación. Más info en: " + "tuquinielaya.web.app/" + this.quiniela.url;
      }

      if (aleatorio == 2) {
        for (let partidoJugado of this.quinielasJugadas) {
          if (partidoJugado.id_partido == partido.$key && jugadores[i].$key == partidoJugado.id_jugador) {
            var texto =
              "⚽ *TuQuinielaYa* ⚽ \n Buenas " + jugadores[i].nombre +
              ". Recuerda que para ver tu posicion en la tabla de puntuación debes entrar en: tuquinielaya.web.app/" + this.quiniela.url;
          }
        }
      }

      if (aleatorio == 3) {
        for (let partidoJugado of this.quinielasJugadas) {
          if (partidoJugado.id_partido == partido.$key && jugadores[i].$key == partidoJugado.id_jugador) {
            var texto =
              "⚽ *TuQuinielaYa* ⚽ \n Le informa que en el partido " +
              partido.contrincante1 + " vs " + partido.contrincante2 +
              ". El resultado actual es " + partido.resultado1 + " a " + partido.resultado2 + " y usted coloco " +
              partidoJugado.resultado1 + " a " + partidoJugado.resultado2;
          }
        }
      }

      if (aleatorio == 4) {
        var texto =
          "⚽ *TuQuinielaYa* ⚽ \n Saludos " + jugadores[i].nombre +
          ". Con los resultados actuales su posición en la tabla  de puntuación es " + posicion +
          " . Para más información: \n tuquinielaya.web.app/" +
          this.quiniela.url;
      }

      if (aleatorio == 5) {
        var texto =
          "⚽ *TuQuinielaYa* ⚽ \n Estimado " + jugadores[i].nombre +
          ". Para ver la quiniela de algun participante pulsa en su nombre en la tabla de puntuación \n tuquinielaya.web.app/" +
          this.quiniela.url;
      }

      if (aleatorio == 6) {
        for (let partidoJugado of this.quinielasJugadas) {
          if (partidoJugado.id_partido == partido.$key && jugadores[i].$key == partidoJugado.id_jugador) {
            var texto =
              "⚽ *TuQuinielaYa* ⚽ \n " + jugadores[i].nombre + " te recordamos que hoy se juega el partido " +
              partido.contrincante1 + " vs " + partido.contrincante2 +
              ". Y el resultado actual es " + partido.resultado1 + " a " + partido.resultado2 + " en su quiniela usted coloco " +
              partidoJugado.resultado1 + " a " + partidoJugado.resultado2;
          }
        }
      }

      if (aleatorio == 7) {
        var texto =
          "⚽ *TuQuinielaYa* ⚽ \n Hola " + jugadores[i].nombre +
          ". Recuerda que si aciertas el resultado exacto de un partido obtienes tres puntos mientras" +
          " que si aciertas solo el equipo ganador o un empate obtienes un punto. Ve tu puntaje en: \n tuquinielaya.web.app/" +
          this.quiniela.url;
      }

      if (aleatorio == 8) {
        for (let partidoJugado of this.quinielasJugadas) {
          if (partidoJugado.id_partido == partido.$key && jugadores[i].$key == partidoJugado.id_jugador) {
            var texto =
              "⚽ *TuQuinielaYa* ⚽ \n Epale " + jugadores[i].nombre + " hoy se juega el partido  " +
              partido.contrincante1 + " vs " + partido.contrincante2 +
              ". El resultado actual es " + partido.resultado1 + " a " + partido.resultado2 + " en tu quiniela colocaste que quedaria " +
              partidoJugado.resultado1 + " a " + partidoJugado.resultado2;
          }
        }
      }

      if (aleatorio == 9) {
        var texto =
          "⚽ *TuQuinielaYa* ⚽ \n Epale " + jugadores[i].nombre +
          ". Usted se encuentra de " + posicion +
          " en la tabla de puntuación. Para visualizar la tabla de puntuación debes acceder a: \n tuquinielaya.web.app/" +
          this.quiniela.url;
      }

      if (aleatorio == 10) {
        var texto =
          "⚽ *TuQuinielaYa* ⚽ \n Hola " + jugadores[i].nombre +
          ". Con la tabla de puntuación actualizada su posición es " + posicion +
          ". Recuerda visitar \n tuquinielaya.web.app/" +
          this.quiniela.url + " para más detalles.";
      }

      // Mediante el Servicio de SMS se envia el mensaje de texto
      var seraEnviado = Math.floor(Math.random() * (2 - 0 + 1) + 0);
      if (seraEnviado == 1) {
        this.SmsService.enviar(numero, texto);
      }
    }

  }

  cargarPlatilla(): void {
    const PS = this.PlantillasService.getAllPlantillas().subscribe((items) => {
      this.plantillas = items.map(
        (item) =>
        ({
          ...item.payload.doc.data(),
          $key: item.payload.doc.id,
        } as Plantilla)
      );
      PS.unsubscribe();
      if (this.partidos.length == 0 && JSON.parse(this.plantillas[0].data).length != 0) { // Solo cuando no existen partidos cargados
        let timerInterval
        Swal.fire({
          title: 'Espere...',
          html: 'Se van a cargar los partidos de forma automática. Espere <b></b> millisegundos. Igualmente, si desea usted puede borrar los partidos y agregar otros.',
          timer: 10000,
          timerProgressBar: true,
          didOpen: () => {
            Swal.showLoading()
            const b = Swal.getHtmlContainer().querySelector('b')
            timerInterval = setInterval(() => {
              b.textContent = `${Swal.getTimerLeft()}`
            }, 100)
          },
          willClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            console.log('I was closed by the timer')

            // Se Obtienen las platillas (Solo existe una por el momentos pero hay una coleeccion para el futuro)


            console.log(this.plantillas[0].data); // Todos los partidos en string
            console.log(JSON.parse(this.plantillas[0].data));
            const partidosMudial = JSON.parse(this.plantillas[0].data); // Todos los partidos en JSON

            partidosMudial.forEach(item => {
              // Creando el Objeto con el Modelo
              const dataPartido: Partido = {
                idQuiniela: this.quiniela.$key,
                fecha: item.fecha,
                contrincante1: item.contrincante1,
                resultado1: null,
                contrincante2: item.contrincante2,
                resultado2: null,
              };

              // Enviar a Firebase por medio del Servicio
              this.PartidosService.createPartido(dataPartido).then((res) => {
                console.log("Se ha creado con exito el Partido", dataPartido);
              });
            })
          }
        })
      }
    });
  }


}
